export default __webpack_public_path__ + "static/media/AG_Helvetica.e258f966.woff2";